const AmazonPaymentModalMarketplaceIds = [2, 15];
const EbayMarketplaceIds = [
  1, // og ebay
  52, // ebay uk
  53, // ebay ca
  99, // ebay au
  141, // ebay fr
  144, // eBay
];

const TikTokMarketplaceId = 4008;

const TikTokMarketplaceUKId = 4106;

const SheinMarketplaceId = 4009;

export const shouldShowTheAmazonPaymentModal = (marketplaceId) => AmazonPaymentModalMarketplaceIds.includes(marketplaceId);

export const isEbayMarketplace = (marketplaceId) => EbayMarketplaceIds.includes(marketplaceId);

export const isTikTokMarketplace = (marketplaceId) => marketplaceId === TikTokMarketplaceId;

export const isTikTokUKMarketplace = (marketplaceId) => marketplaceId === TikTokMarketplaceUKId;

export const isSheinMarketplace = (marketplaceId) => marketplaceId === SheinMarketplaceId;
